// These country codes need to display a new auto-renewal prompt due to price changes. This list might change in the future.
// https://alltrails.atlassian.net/browse/GROW-1057

export default ['US', 'CA', 'GB', 'AU', 'NZ', 'IE', 'NL', 'BE', 'LU', 'DK', 'SE', 'NO', 'IS', 'FI', 'CH'];
